import { miniPacketHooks } from './useDevicePacket';

export const useGenerateMiniPacket = miniPacketHooks.useGeneratePacket;
export const useParseMiniPacket = miniPacketHooks.useParsePacket;
